import * as DetailsStyles from './Details.styles'
import * as DetailsHeaderStyles from './DetailsHeader.styles'
import * as TabsStyles from './Tabs.styles'

export const StyledDetails = DetailsStyles
export const StyledDetailsHeader = DetailsHeaderStyles
export const StyledTabs = TabsStyles
export { default as DetailsOverview } from './DetailsOverview'
export { default as useDetailsLazyQuery } from './useDetailsLazyQuery.hook'
export * from './Details.consts'
